import { DownloadIcon, EyeIcon, FileSearchIcon } from 'lucide-react';
import { TextLink, Tooltip } from '@shared/components';
import type { GeneratedDocument } from '../../types/agreementDocuments.types';

interface Props {
    document: GeneratedDocument;
    label: string;
    canRead: boolean;
    onView?: (document: GeneratedDocument) => void;
    onDownload?: (document: GeneratedDocument) => void;
    onDetails: (document: GeneratedDocument) => void;
}

export function DocumentRowActions({ document, label, canRead, onView, onDownload, onDetails }: Props) {
    const readable = canRead && document.status === 'generated';

    return (
        <div className="flex items-center justify-end gap-3">
            {readable && onView && (
                <Tooltip content="View">
                    <TextLink ariaLabel={`View ${label}`} color="primary" startIcon={<EyeIcon size={20} />} onClick={() => onView(document)} />
                </Tooltip>
            )}
            {readable && onDownload && (
                <Tooltip content="Download">
                    <TextLink ariaLabel={`Download ${label}`} color="primary" startIcon={<DownloadIcon size={20} />} onClick={() => onDownload(document)} />
                </Tooltip>
            )}
            <Tooltip content="Details">
                <TextLink ariaLabel={`Details of ${label}`} color="secondary" startIcon={<FileSearchIcon size={20} />} onClick={() => onDetails(document)} />
            </Tooltip>
        </div>
    );
}
